const desktopCarouselSelector = '.desktop-carousel';
const tabletCarouselSelector = '.tablet-carousel';
const mobileCarouselSelector = '.mobile-carousel';
const carouselInnerSelector = '.carousel-inner';
const carouselControlSelector = '.carousel-control';
const carouselControlWrapperSelector = '.carousel-controls-wrapper';
const dynamicContentItem2Selector = '.dynamic-content2-item';
const desktopCarouselDuration = 'data-desktop-carouselduration';
const tabletCarouselDuration = 'data-tablet-carouselduration';
const mobileCarouselDuration = 'data-mobile-carouselduration';
const idAttribute = 'id';
const itemClassName = 'item';
const activeClassName = 'active';
const slideClassName = 'slide';
const carouselClassName = 'carousel';
const sfHomeCarouselSelector = '.categoryList-Carousel';
const sfImageSelector = 'img.img-responsive';
const smalFormatlHomeCardSelector = '.inspirationCard.has-homepage-small-image';
const smalFormatlHomeCardTextSelector = '.inspirationCard.has-homepage-small-image .inspirationCard-textWrapper.is-showing-image';

function DynamicContentCarouselService(settingsService, $templateRequest) {
    this.smallFormatHomeCarouselHeight = 0;
    this.indicatorColor = null;
    this.settingsService = settingsService;
    this.$templateRequest = $templateRequest;
    const self = this;
    this.settingsService.getSettingValue('DynamicContent', 'DynamicContentCarouselIndicatorColor').then(function (color) { self.indicatorColor = color; });
}


DynamicContentCarouselService.prototype.populateIndicator = function (elm, id) {
    const itemCount = elm.find(dynamicContentItem2Selector).length;
    let indicators = '<ol class="carousel-indicators">';

    const indicatorStyle = this.indicatorColor != null ? `style="background-color:${this.indicatorColor}"` : null;
    for (let i = 0; i < itemCount; i++) {
        if (i === 0) {
            indicators += `<li data-target="#${id}" data-slide-to="${i}"  class="active" ${indicatorStyle}></li>`;
        } else {
            indicators += `<li data-target="#${id}" data-slide-to="${i}" ${indicatorStyle}></li>`;
        }
    }
    indicators += '</ol>';

    elm.find(carouselInnerSelector).before(indicators);
};

DynamicContentCarouselService.prototype.populateControls = function (elm, id) {
    const controlsRight = `<a class="right carousel-control carousel-control-type-2" href="#${id}" role="button" data-slide="next">` +
        `<span class="icon--right_arrow carousel-control-arrow" aria-hidden="true"></span>` +
        `<span class="sr-only">Next</span>` +
        `</a>`;

    const controlsLeft = `<a class="left carousel-control carousel-control-type-2" href="#${id}" role="button" data-slide="prev">` +
    `<span class="icon--left_arrow carousel-control-arrow" aria-hidden="true"></span>` +
    `<span class="sr-only">Previous</span>` +
    `</a>`;

    elm.find('.carousel-indicators').wrap('<div class=\'carousel-controls-wrapper\' />');
    elm.find('.carousel-indicators').before(controlsLeft).after(controlsRight);
};

DynamicContentCarouselService.prototype.initializeCarousel = function (elm, id, duration) {
    if (elm.find(carouselInnerSelector).length !== 0) {
        return;
    }
    elm.addClass(carouselClassName).addClass(slideClassName);
    elm.find(dynamicContentItem2Selector).addClass(itemClassName).wrapAll('<div class=\'carousel-inner\' />');
    elm.find(dynamicContentItem2Selector).eq(0).addClass(activeClassName);
    this.populateIndicatorsAndControls(elm, id, duration);
};

DynamicContentCarouselService.prototype.populateIndicatorsAndControls = function (elm, id, duration) {
    this.populateIndicator(elm, id);
    this.populateControls(elm, id);
    const option = {
        lazyLoad: 'ondemand',
        pause: 'hover',
        swipe: 30
    };
    if (duration !== undefined && duration > 0) {
        duration = duration >= 1000 ? duration : duration * 1000;
        option.interval = duration;
    }
    elm.carousel(option);
};

function updateCardImageHeight(carousel, height) {
    const cardHeight = height - 20;
    carousel.find(smalFormatlHomeCardSelector).css('height', cardHeight);
    carousel.find(smalFormatlHomeCardTextSelector).css('width', `calc(100% - ${cardHeight}px)`);
}

DynamicContentCarouselService.prototype.init = function () {
    const dynamicContentWindowWidthCal = $(window).width();
    const isScrollBarCal = $(document).height() > $(window).height();
    const transitionWidthCal = isScrollBarCal ? 950 : 960;
    if (dynamicContentWindowWidthCal > transitionWidthCal) {
        this.initializeCarouselBySelector(desktopCarouselSelector);
    } else if (dynamicContentWindowWidthCal > 767) {
        this.initializeCarouselBySelector(tabletCarouselSelector);
    } else {
        this.initializeCarouselBySelector(mobileCarouselSelector);
    }
};


DynamicContentCarouselService.prototype.initializeCarouselBySelector = function (selector) {
    const self = this;
    $(selector).each(function (i, v) {
        const id = $(v).attr(idAttribute);
        const durationAttr = selector === desktopCarouselSelector ? desktopCarouselDuration : selector === tabletCarouselSelector ? tabletCarouselDuration : mobileCarouselDuration;
        const duration = $(v).attr(durationAttr);

        if ($(v).find(carouselInnerSelector).length === 0) {
            self.initializeCarousel($(v), id, duration);
        } else if ($(v).find(carouselControlWrapperSelector).length === 0) {
            if ($(v).find(carouselControlSelector).length > 0) {
                $(v).find(carouselControlSelector).remove();
            }

            self.populateIndicatorsAndControls($(v), id, duration);
        }
    });
};

DynamicContentCarouselService.prototype.getSmallFormatHomeCarouselHeight = function () {
    let height = 0;
    const sfHomeCarousel = $(sfHomeCarouselSelector).find(mobileCarouselSelector);
    if (sfHomeCarousel.length) {
        const images = sfHomeCarousel.find(sfImageSelector);
        const parentItem = $(images[0]).parents(dynamicContentItem2Selector);
        const visible = parentItem.hasClass(activeClassName);
        if (!visible) {
            parentItem.addClass(activeClassName);
        }
        height = $(images[0]).height();
        if (!visible) {
            parentItem.removeClass(activeClassName);
        }
        updateCardImageHeight(sfHomeCarousel, height);
    }
    return height;
};

module.exports = DynamicContentCarouselService;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/dynamiccontent/dynamic-content-carousel-service.js
 **/